import { Box } from "@mui/material";
import "@plannel/scss/components/AggregationIcon.scss";

const AggregationGifIcon = () => {
  return (
    <Box sx={{ width: "20px", height:"20px", position:"relative"}}>
    <section className="abs-center container">
      <div className="cube cube1">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube2">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube3">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube4">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube5">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube6">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube7">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube8">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube9">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube10">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube11">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube12">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube13">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div></div>
      <div className="cube cube14">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube15">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube16">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube17">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube18">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube19">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube20">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube21">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube22">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube23">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube24">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube25">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube26">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
      <div className="cube cube27">
        <div className="front"></div>
        <div className="left" ></div>
        <div className="top"  ></div>
      </div>
    </section>
    </Box>
  );
}

export {
  AggregationGifIcon
};
// Copyright (c) 2023 by Kyle Shanks (https://codepen.io/mavrK/pen/vKQjgB)